
      if (!("fetch" in window && "assign" in Object)) {
        // Load fallback for browsers that don't support fetch and Object.assign
        import("/src/fallback.js").then(() => {
          console.log("Feature detection for modern browser APIs.");
        });
      }
    